import { render, staticRenderFns } from "./DialogAddGood.vue?vue&type=template&id=4ab28564&scoped=true&"
import script from "./DialogAddGood.vue?vue&type=script&lang=js&"
export * from "./DialogAddGood.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab28564",
  null
  
)

export default component.exports